// Custom code: ?
// document.addEventListener( "product:variant-change", function ( e ) {
// 	const id = e.detail?.variant?.id
// 	if ( !id ) {
// 		return
// 	}

// 	document.querySelector( ".product.product-page" ).dataset.variantId = id
// } )

// Custom code: availability
(function initAvailability() {
	document.addEventListener("DOMContentLoaded", initWidget);

	subscribe(PUB_SUB_EVENTS.productVariantChange, function (data) {
		updateWidgetOnVariantChange(data?.variant?.id);
	});

	// subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
	// 	if (!data?.cartData?.items) return;
	// 	updateLineDates(data.cartData.items);
	// });

	// subscribe(PUB_SUB_EVENTS.cartItemAdd, async function () {
	// 	const res = await fetch(`/cart.js`);
	// 	const cart = await res.json();
	// 	updateLineDates(cart.items);
	// });

	function createItemsMap(items) {
		const itemsMap = new Map();
		for (const { variant_id, quantity, key, url, properties } of items) {
			if (!itemsMap.has(variant_id)) {
				itemsMap.set(variant_id, {
					keys: [],
					keyQuantities: [],
					totalQuantity: 0,
					url,
					properties,
				});
			}
			const entry = itemsMap.get(variant_id);
			itemsMap.set(variant_id, {
				...entry,
				keys: [...entry.keys, key],
				keyQuantities: [...entry.keyQuantities, quantity],
				totalQuantity: entry.totalQuantity + quantity,
			});
		}

		return itemsMap;
	}

	async function fetchAvailabilityData(variantId, itemData) {
		const { keys, keyQuantities, totalQuantity, url, properties } = itemData;

		const productHandle = url.split("/").pop().split("?")[0];
		const html = await getVariantDataFromServer(productHandle, variantId);
		const { variantData, globalData, manufacturerData, texts } =
			extractVariantDataFromHTML(html);

		if (!variantData || !globalData) {
			console.error("Missing data:", { variantData, globalData });
			return null;
		}
		const message = formulateText(
			{
				globalData,
				manufacturerData,
				variantData,
				texts,
			},
			totalQuantity,
			true,
		);

		return {
			keys,
			keyQuantities,
			properties,
			message,
			propertyText: texts.property || "Delivery",
			hasSplitItem: totalQuantity > variantData.quantity,
		};
	}

	async function getCartUpdateData(items) {
		const itemsMap = createItemsMap(items);

		let propertyText = "Delivery";
		let hasSplitItem = false;

		const messageItems = await Promise.all(
			[...itemsMap.entries()].map(async function ([variantId, itemData]) {
				return await fetchAvailabilityData(variantId, itemData);
			}),
		);

		propertyText = messageItems[0]?.propertyText || "Delivery";
		hasSplitItem = messageItems.some((item) => item?.hasSplitItem);

		const changes = [];

		for (const item of messageItems.filter(Boolean)) {
			const { keys, properties, message } = item;
			for (let i = 0; i < keys.length; i++) {
				const key = keys[i];
				const quantity = item.keyQuantities[i];
				changes.push({
					id: key,
					quantity,
					properties: { ...properties, [propertyText || "Shipping"]: message },
				});
			}
		}

		return {
			changes,
			hasSplitItem,
		}
	}

	window.Availability = {
		updateLineDates,
	}

	async function updateLineDates(items, finalBodyExtra = {}, skipRefresh = false) {
		if (!items) {
			const freshCart = await fetch(`${Shopify.routes.root}cart.js`).then((res) => res.json());
			items = freshCart.items;
		}

		const { changes, hasSplitItem } = await getCartUpdateData(items);

		for (const change of changes) {
			await fetch(`${Shopify.routes.root}cart/change.js`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(change),
			});
		}

		if (!skipRefresh) {
			document.querySelector("mini-cart")?.updateSectionContents();
		}

		const finalBody = {
			attributes: {
				_allow_split_ship: String(hasSplitItem),
			},
			...finalBodyExtra,
		}

		const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
			body: JSON.stringify(finalBody),
			method: "POST",
			headers: { "Content-Type": "application/json", Accept: `application/json` },
		});

		return res
	}

	function initWidget() {
		refreshWidget(document, null);
	}

	function updateWidgetOnVariantChange(variantId) {
		refreshWidget(null, variantId);
	}

	async function refreshWidget(dataHtml, variantId) {
		const container = document.querySelector("#AvailabilityContainer");
		if (!container) {
			return;
		}

		if (!dataHtml && !variantId) {
			console.error("Missing args");
			container.remove();
			return;
		}

		let html = dataHtml;
		if (!dataHtml) {
			const productHandle = window.location.pathname.split("/").pop();
			html = await getVariantDataFromServer(productHandle, variantId);
		}

		const data = extractVariantDataFromHTML(html);
		if (!data.variantData || !data.globalData) {
			console.error("Missing data:", { variantData, globalData });
			container.remove();
			return;
		}

		const message = formulateText(data);
		updateWidgetText(message);
	}

	function updateWidgetText(message) {
		const placeholder = document.querySelector("#AvailabilityPlaceholder");
		if (placeholder) {
			const content = document.createElement("div");
			content.id = "AvailabilityContent";
			content.innerHTML = message;
			placeholder.parentNode.replaceChild(content, placeholder);
		} else {
			document.querySelector("#AvailabilityContent").innerHTML = message;
		}
	}

	async function getVariantDataFromServer(productHandle, variantId) {
		const res = await fetch(
			`${Shopify.routes.root}products/${productHandle}?variant=${variantId}&section_id=availability-helper`,
		);
		const text = await res.text();
		const html = new DOMParser().parseFromString(text, "text/html");
		return html;
	}

	function extractVariantDataFromHTML(html) {
		const texts = JSON.parse(
			html.querySelector("#AvailabilityTexts").innerHTML,
		);
		const variantDataEl = html.querySelector("#AvailabilityConfig");
		const globalDataEl = html.querySelector("#AvailabilityDataGlobal");
		const manufacturerDataEl = html.querySelector(
			"#AvailabilityDataManufacturer",
		);
		if (!globalDataEl || !variantDataEl || !texts) {
			return {
				variantData: null,
				globalData: null,
				manufacturerData: null,
				texts: null,
			};
		}

		const variantData = JSON.parse(variantDataEl?.innerHTML);
		const globalData = JSON.parse(globalDataEl.innerHTML);
		const manufacturerData = JSON.parse(manufacturerDataEl?.innerHTML || "{}");

		return {
			variantData,
			globalData,
			manufacturerData,
			texts,
		};
	}

	function formulateText(
		{ globalData, manufacturerData, variantData, texts },
		totalQuantity = null,
		shortDate = false,
	) {
		const { timezone, policy, quantity: relativeQuantity } = variantData;
		const quantity = Math.max(0, relativeQuantity);

		const mergedData = {};
		for (const k of Object.keys(globalData)) {
			const globalValue = globalData[k];
			const manufacturerValue = manufacturerData[k];
			mergedData[k] = manufacturerValue || globalValue;
		}

		const {
			cut_off_time: cutOffTime,
			days: workDays,
			holidays,
			processing_days: processingDays,
			shipping_days: shippingDays,
			out_of_stock_processing_days_allow_overselling: outOfStockAllow,
			out_of_stock_processing_days_deny_overselling: outOfStockDeny,
		} = mergedData;

		const [cutHour, cutMinute] = cutOffTime.split(":").map(Number);
		const now = new Date();

		const tzRaw = /^[+-]/.test(timezone) ? timezone : `+${timezone}`;
		const tzMatch = tzRaw.match(/^([+-])(\d{2})(\d{2})$/);
		if (!tzMatch) {
			console.error("Invalid timezone:", timezone);
			return;
		}
		const [, sign, hh, mm] = tzMatch;
		const offsetMinutes = parseInt(hh, 10) * 60 + parseInt(mm, 10);
		const offsetMs = (sign === "+" ? 1 : -1) * offsetMinutes * 60000;
		const utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
		const local = new Date(utcMs + offsetMs);

		const afterCutoff =
			local.getHours() > cutHour ||
			(local.getHours() === cutHour && local.getMinutes() >= cutMinute);
		const extraDay = afterCutoff ? 1 : 0;

		const availableEffectiveProcessingDays = processingDays;
		const unavailableEffectiveProcessingDays =
			policy === "continue" ? outOfStockAllow : outOfStockDeny;

		const availableTotalDays =
			availableEffectiveProcessingDays + extraDay + parseInt(shippingDays, 10);
		const unavailableTotalDays =
			unavailableEffectiveProcessingDays +
			extraDay +
			parseInt(shippingDays, 10);

		const isWorkingDay = (date) => {
			const dayName = date.toLocaleString("en-US", { weekday: "long" });
			const iso = date.toISOString().slice(0, 10);
			return (
				(workDays || []).includes(dayName) && !(holidays || []).includes(iso)
			);
		};

		let availableCount = 0,
			availableDeliveryDate = new Date(local);
		while (availableCount < availableTotalDays) {
			availableDeliveryDate.setDate(availableDeliveryDate.getDate() + 1);
			if (isWorkingDay(availableDeliveryDate)) availableCount++;
		}

		let unavailableCount = 0,
			unavailableDeliveryDate = new Date(local);
		while (unavailableCount < unavailableTotalDays) {
			unavailableDeliveryDate.setDate(unavailableDeliveryDate.getDate() + 1);
			if (isWorkingDay(unavailableDeliveryDate)) unavailableCount++;
		}

		let nextCut = new Date(local);
		if (!isWorkingDay(local) || afterCutoff) {
			do {
				nextCut.setDate(nextCut.getDate() + 1);
			} while (!isWorkingDay(nextCut));
		}
		nextCut.setHours(cutHour, cutMinute, 0, 0);

		const locale = Shopify?.locale || navigator.language || "en-US";
		const availableDateStr = new Intl.DateTimeFormat(
			locale,
			shortDate
				? { month: "short", day: "numeric" }
				: { weekday: "long", month: "long", day: "numeric" },
		).format(availableDeliveryDate);
		const unavailableDateStr = new Intl.DateTimeFormat(
			locale,
			shortDate
				? { month: "short", day: "numeric" }
				: { weekday: "long", month: "long", day: "numeric" },
		).format(unavailableDeliveryDate);

		let message = "";

		if (totalQuantity != null) {
			if (quantity >= totalQuantity) {
				return "";
			}

			const diff = totalQuantity - quantity;
			message = `${quantity} ready to ship, ${diff} due on ${unavailableDateStr}`;

			return message;
		}

		if (quantity > 0) {
			message += texts.availableText
				.replace("$1", quantity)
				.replace(
					"$2",
					`${availableCount === 2 ? `${texts.tomorrow}, ` : ""}${availableDateStr}`,
				)
				.replace("$3", `${unavailableDateStr}`);
		} else {
			message += texts.unavailableText.replace("$1", `${unavailableDateStr}`);
		}
		message += "<br />";

		// const extraText = document.querySelector( '#AvailabilityExtraText' ).innerHTML;
		// if ( extraText ) {
		// 	message += extraText;
		// }

		return message;
	}
})();
